import { Page, Text, View, Document, StyleSheet ,Font ,Image} from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import Header from "./Header";
import Footer from "./Footer";

Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
});

  const styles = StyleSheet.create({
    pagewapper: {
        position: "relative",
        height: "100%"
    },
    content: {
        // marginTop: "35px",
        display: "flex",
        width: "570px",
        alignItems: "left"
    },
      contenttitle: {
        fontFamily: "Lato",
        fontWeight: 700,
        fontSize: "18px",
        lineHeight: "30px",
        color: "#426B88"
    },
    wapper: {
        width: "567px",
        fontFamily: "Lato",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "18px",
        color: "#245775"
      },
      mainContent: {
          flexGrow: 1,
          marginTop:"28px",
    },
    footer: {
        marginTop: 'auto',
    },
    table: {
        width: '100%',
        // borderWidth: 1,
        // borderColor: '#ccc',
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 2,
        alignItems: 'center',
    },
      tableHeader: {
        paddingVertical: 1,
        fontWeight: 400,
        border:'0px',
        backgroundColor: '#245775',
        fontWeight: 'bold',
        color: 'white',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
    headerCell:{color: 'white', fontWeight:400, paddingVertical:"5px"},
    cellQuestion: { width: '70%', fontSize: 10,color:"#394554", fontWeight:400},
    cellScore: { width: '7%', textAlign: 'center', fontSize: 10 },
    cell: {
        padding: "10px",
        textAlign: "left",
      },
      
      rowEven: {
        backgroundColor: "#F1F3F3",
      },
      rowOdd: {
        backgroundColor: "#FFF",
      },
      redRectangle: {
        width: 17,
        height: 17,
          backgroundColor: '#667F96',
        borderRadius:"1.34px",
    },
      
  });

  const truncateText = (text, limit) => {
    if (text.length <= limit) return text;
    return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
  };

  const renderRectangle = (value) => {
    return value === 1 ? (
        <View style={styles.redRectangle} />
    ) : null;
};


const TableOfContents = () => (
    <View style={styles.pagewapper}>
    <Header />
         <View style={styles.content}>
         <Text style={styles.contenttitle}>MIND IN FOCUS</Text>
                        <View style={styles.wapper}>
                            <Text>This chart isolates the items related to the Mind and ranks them highest to lowest based on the participants self-rating. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.</Text>
                        </View>         
        </View>
        <View style={styles.mainContent}>
            <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>Mind</Text>
                {[1, 2, 3, 4].map((num) => (
                    <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]}>
                        {num}
                    </Text>
                ))}
            </View>

            {data.map((item, index) => (
                <View key={index} style={[
                    styles.tableRow, 
                    index % 2 === 0 ? styles.rowEven : styles.rowOdd
                ]}>
                    <Text style={[styles.cell, styles.cellQuestion]}>{truncateText(item.question, 80)}</Text>
                    {item.scores.map((score, index) => (
                        <View key={index} style={[styles.cell, styles.cellScore]}>
                            {renderRectangle(score)}
                        </View>
                    ))}

                </View>
            ))}
        </View>

    <Footer/>
</View>

);

export default TableOfContents;

const data = [
  {
    "quadrant": "Mind",
    "question": "When presented with a problem, I need to understand the processes before I can start.",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "Mind",
    "question": "I make decisions based on the policies that guide me.",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "Mind",
    "question": "I am most fulfilled when a project works like it was planned.",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "Mind",
    "question": "I am motivated when everything has been thoughtfully planned out.",
    "scores": [1, 1, 1, 1]
  },
  {
    "quadrant": "Mind",
    "question": "I need clear responsibilities to function well in my work.",
    "scores": [1, 1, 1, 0]
  },
  {
    "quadrant": "Mind",
    "question": "My superpower is analyzing the problem for a solution.",
    "scores": [1, 1, 1, 0]
  },
  {
    "quadrant": "Mind",
    "question": "I find satisfaction in developing standardized procedures.",
    "scores": [1, 1, 1, 0]
  },
  {
    "quadrant": "Mind",
    "question": "When working on a project, I can get stuck by overthinking everything.",
    "scores": [1, 1, 0, 0]
  },
  {
    "quadrant": "Mind",
    "question": "I believe the right structures are essential for an effective organization.",
    "scores": [1, 0, 0, 0]
  },
  {
    "quadrant": "Mind",
    "question": "I find satisfaction in developing standardized procedures.",
    "scores": [1, 0, 0, 0]
  },
  {
    "quadrant": "Mind",
    "question": "I find satisfaction in developing effective systems.",
    "scores": [1, 0, 0, 0]
  }
];
